import { get } from '@core/api/baseApi';
import { User } from '../types/User';

const getUser = (userId:string | undefined): Promise<User> => get(`/users/${userId ?? -1}`);

export default getUser;
